import React from 'react';
import classNames from 'classnames';
/**
 * Bronson Logo component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-logo.html
 * @constructor
 */
export function Logo({ align, alt, ariaLabel, className, custom, disableLink, height, heightSmall, href, onClick, src, srcSmall, testId, ...otherProps }) {
    /**
     * Conditionally add {@link height}, {@link heightSmall} and/or {@link align} as custom props.
     * @type {React.CSSProperties}
     */
    const logoCustomProps = {
        ...(height && { '--logo-image-height': height }),
        ...(heightSmall && { '--logo-image-height-small': heightSmall }),
        ...(align && { '--logo-image-align': align }),
    };
    const aClassNameList = classNames('c-logo', {
        'c-logo--custom': custom,
    }, className).trim();
    /**
     * Merge the {@link logoCustomProps} into an existing style prop.
     */
    const logoStyles = { ...(otherProps?.style ?? {}), ...logoCustomProps };
    /**
     * Render the logo image(s).
     */
    function renderIfSrc() {
        if (src) {
            return (React.createElement(React.Fragment, null,
                srcSmall && React.createElement("img", { src: srcSmall, alt: alt || '', className: "c-logo__image-small" }),
                React.createElement("img", { src: src, alt: alt || '', className: "c-logo__image" })));
        }
        else {
            return null;
        }
    }
    /**
     * Conditionally render a `<span>` as Logo wrapper.
     * @type {string}
     */
    const LogoElement = disableLink ? 'span' : 'a';
    return (React.createElement(LogoElement, { className: aClassNameList, "data-testid": testId, "aria-label": disableLink ? undefined : ariaLabel, onClick: disableLink ? undefined : onClick, href: disableLink ? undefined : href, ...otherProps, style: logoStyles }, renderIfSrc()));
}
